import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CreateNote from './CreateNote';
import EditNote from './EditNote';

const TeacherNotesLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CurriculumStudents' */ './components/TeacherNotes'
		)
);

export default (store) => {
	return [
		{
			path: 'home/teacher-notes',
			element: <AsyncLoading component={<TeacherNotesLazy />} />,
		},
		CreateNote(store),
		EditNote(store),
	];
};
